export const overFlowDosyaCountMessageId = "overFlowDosyaCountMessage-Id";
export const minimumDosyaCountId = "minimumDosyaCount-Id";
export const minimumTokenCountId = "minimumTokenCount-Id";
export const minimumUserCountId = "minimumUserCount-Id";
export const minimumFeatureTypeSelectionMessageId = "minimumFeatureTypeSelectionMessage-Id";
export const warningTenantPropertiesCountId = "overFlowDosyaCountMessage-Id";

export const overFlowDosyaCountMessage = 'Size Özel Üyelik Modelinizi  Belirlemek İçin  Müşteri Temsilciniz İle İletişime Geçiniz. 90 212 987 51 00';
export const minimumDosyaCount = 'Açık UYAP Dosya Sayısı en az 1 Olabilir';
export const minimumTokenCount = 'TOKEN\'lı Avukat Sayısı en az 1 Olabilir';
export const minimumUserCount = 'Kullanıcı Sayısı en az 1 Olabilir';
export const warningTenantPropertiesCountMessage = 'Önceki üyeliğinizden daha aşağıda özellik seçemezsiniz!';
export const minimumFeatureTypeSelectionMessage = 'En az 1 Tane Özellik Seçmeniz Gerekmektedir';
export const selectSubscriptionBillingTypeMessage = "Abonelik Tipi Seçiniz!";
export const errorMessage = 'Hata Oluştu';
export const connectionErrorMessage = 'Bağlantı Hatası Oluştu';
export const usernameOrLgPwError = 'Kullanıcı Adı veya Şifre Hatalı!';
export const copyRight = 'Copyright © 2020/etcBASE. All rights reserved';
export const ugyHeaderText = '/etcBASE UYAP Görev Yöneticisi Abonelik Ücreti Hesaplama';
export const ahtabotHeaderText = '/etcBASE AHTABOT Abonelik Ücreti';
export const headerTextLogin = '/etcBASE UYAP Görev Yöneticisi';
export const helpdeskPhoneNumber = '+90 212 987 51 00';

export const companyName = 'ETCBASE YAZILIM VE BİLİŞİM TEKNOLOJİLERİ A.Ş.';

export const contactColumns = [
    {
        title: 'Web Sitesi',
        lines: [
            {label: 'www.etcbase.com/ahtabot', href: 'https://www.etcbase.com/ahtabot'}
        ]
    },
    {
        title: 'Helpdesk',
        lines: [
            {label: helpdeskPhoneNumber},
            {label: 'helpdesk@etcbase.com', href: 'mailto:helpdesk@etcbase.com'}
        ]
    },
    {
        title: 'Ahtabot Üyeliği İçin',
        lines: [
            {label: '+90 531 731 93 75'},
            {label: 'ahtabot@etcbase.com', href: 'mailto:ahtabot@etcbase.com'}
        ]
    },
    {
        title: 'İletişim',
        lines: [
            {label: '+90 212 987 50 00'},
            {label: 'info@etcbase.com', href: 'mailto:info@etcbase.com'}
        ]
    },
    {
        title: 'Adres',
        lines: [
            {label: 'Reşitpaşa Mah. Katar Cad. Arı Teknokent 2 No:4/1 Kat:5 No:501'},
            {label: 'Sarıyer / İstanbul'}
        ]
    }
];
export const currencyTypeTl = ' TL';
export const percentageSing = ' %';
export const maxCount = 2147483648;

const baseUrl = '..';
export const initUrl = `${baseUrl}/api/subscription/init`;
export const calculateUrl = `${baseUrl}/api/subscription/calculate`;
export const authUrl = `${baseUrl}/api/v1/public/authenticate`;
export const tenantInfoUrl = `${baseUrl}/api/subscription/tenant`;
export const showUserPanelUrl = `${baseUrl}/api/subscription/showUserPanel`;
export const presaleMaxFileCountUrl = `${baseUrl}/api/subscription/presaleMaxFileCount`;
export const featureTypeListUrl = `${baseUrl}/api/subscription/featureTypeList`;
export const payUrl = `${baseUrl}/api/subscription/payment`;
export const testSuccessPaymentUrl = `${baseUrl}/api/subscription/paymentResult/success`;
export const testErrorPaymentUrl = `${baseUrl}/api/subscription/paymentResult/error`;
export const getTenantList = `${baseUrl}/api/subscription/getUyapLawOfficeResponseDtoList`;
export const selectTenantId = `${baseUrl}/api/subscription/selectTenant`;
export const updateTenant = `${baseUrl}/api/subscription/updateTenantSubscriptionViewDto`;
export const updateAhtapot = `${baseUrl}/api/subscription/updateAhtapotTenantSubscriptionViewDto`;
export const getPaymentHistoryUrl = `${baseUrl}/api/subscription/getPaymentHistoryData`;
export const getAhtapotSubscriptionPaymentDetailDtoUrl = `${baseUrl}/api/subscription/ahtapot/getAhtapotSubscriptionPaymentDetailDto`;
export const get3AylikAhtapotSubscriptionPaymentDetailDtoUrl = `${baseUrl}/api/subscription/ahtapot/get3AylikAhtapotSubscriptionPaymentDetailDto`;
export const updateTenantSubscriptionStatusUrl = `${baseUrl}/api/subscription/updateTenantSubscriptionStatus`;
export const saveDiscountCouponUrl = `${baseUrl}/api/subscription/discount/saveDiscountCoupon`;
export const generateDiscountCouponCodeUrl = `${baseUrl}/api/subscription/discount/generateDiscountCouponCode`;
export const getDiscountCouponCodeListUrl = `${baseUrl}/api/subscription/discount/getDiscountCouponCodeList`;
export const sendDiscountCouponCodeUrl = `${baseUrl}/api/subscription/discount/sendDiscountCouponCode`;
export const checkReferenceCodeUrl = `${baseUrl}/api/subscription/ahtapot/checkReferenceCode`;
export const getDiscountCouponDtoByIdUrl = `${baseUrl}/api/subscription/discount/getDiscountCouponDtoById`;
export const updateStatusDiscountCouponDtoUrl = `${baseUrl}/api/subscription/discount/updateStatusDiscountCouponDto`;
export const getDiscountCouponListUrl = `${baseUrl}/api/subscription/discount/getDiscountCouponList`;
export const getSelectedTenantListUrl = `${baseUrl}/api/subscription/discount/getSelectedTenantListUrlForDiscountCoupon`;
export const couponManagementCheckUrl = `${baseUrl}/api/subscription/discount/couponManagementCheck`;
export const adminManagementCheckUrl = `${baseUrl}/api/subscription/adminManagementCheck`;
export const getTenantSubscriptionStatementListUrl = `${baseUrl}/api/subscription/ahtapot/getTenantSubscriptionStatementList`;
export const startAhtapotDemoTenantSubscriptionUrl = `${baseUrl}/api/subscription/ahtapot/startAhtapotDemoTenantSubscription`;
export const insertAhtapotTenantSubscriptionUrl = `${baseUrl}/api/subscription/ahtapot/insertAhtapotTenantSubscription`;
export const changeToPresaleFixedUrl = `${baseUrl}/api/subscription/changeToPresaleFixed`;
export const changeAhtapotToPresaleFixedUrl = `${baseUrl}/api/subscription/changeAhtapotToPresaleFixed`;
export const changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUiUrl = `${baseUrl}/api/subscription/changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUi`;
export const deleteAhtapotTenantSubscriptionUrl = `${baseUrl}/api/subscription/ahtapot/deleteAhtapotTenantSubscription`;
export const getAhtapotOptions = `${baseUrl}/api/subscription/ahtapot/getAhtapotOptions`;
export const getPaymentInstallmentsUrl = `${baseUrl}/api/subscription/payment/installments`;
export const getAhtapotUpdateFileCountDtoUrl = `${baseUrl}/api/subscription/ahtapot/getAhtapotUpdateFileCountDto`;
export const getUserSubscriptionAndCalculateFileCountAmountUrl = `${baseUrl}/api/subscription/getUserSubscriptionAndCalculateFileCountAmount`;
export const estimatedAhtapotUpdateFileCountDtoUrl = `${baseUrl}/api/subscription/ahtapot/estimatedAhtapotUpdateFileCountDto`;
export const saveAhtapotUpdateFileCountDtoUrl = `${baseUrl}/api/subscription/ahtapot/saveAhtapotUpdateFileCountDto`;
export const getCityListUrl = `${baseUrl}/api/subscription/ahtapot/city`;
export const getDistrictsByCityIdUrl = `${baseUrl}/api/subscription/ahtapot/district`;
export const getAddressByOwnerTenantIdUrl = `${baseUrl}/api/subscription/ahtapot/address`;
export const saveAddressUrl = `${baseUrl}/api/subscription/ahtapot/address`;
export const getAllMuvekkilTenants = `${baseUrl}/api/subscription/getUyapLawOfficeResponseDtoListForMuvekkilTenants`;
export const getMuvekkilTenantsWithoutSubscription = `${baseUrl}/api/subscription/getUyapLawOfficeResponseDtoListForMuvekkilTenantsWithoutSubscription`;
export const startUgyDemoTenantSubscriptionUrl = `${baseUrl}/api/subscription/ahtapot/startUgyDemoTenantSubscription`;
export const manualPaymentUpdateUrl = `${baseUrl}/api/subscription/manualPaymentUpdate`;

export const helmetTitle = 'Ahtabot/UGY Abonelik Hesapla';
export const defaultRequestDto = {
    openUyapDosyaCount: 1,
    tokenCount: 1,
    userCount: 1,
    subscriptionFeatureTypeRequestDtoList:[]
};
export const defaultAhtapotRequestDto = {
    ahtapotFileCount: 500
};
export const defaultViewDto = {
    oneMonthDto: {
        totalBill: 0,
        discountRate: 0,
        discountedTotalBill: 0
    },
    threeMonthDto: {
        totalBill: 0,
        discountRate: 0,
        discountedTotalBill: 0
    },
    sixMonthDto: {
        totalBill: 0,
        discountRate: 0,
        discountedTotalBill: 0
    },
    oneYearDto: {
        totalBill: 0,
        discountRate: 0,
        discountedTotalBill: 0
    }
};

export const formatCurrency = (amount, decimalSeparator = ',', thousandSeparator = '.', currencySymbol = 'TL') =>
    Number(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
    + ` ${currencySymbol}`;
